var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_FILL0_wght400_GRAD0_opsz48 (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.11289 9.41289L2.58789 8.88789L5.47539 6.00039L2.58789 3.11289L3.11289 2.58789L6.00039 5.47539L8.88789 2.58789L9.41289 3.11289L6.52539 6.00039L9.41289 8.88789L8.88789 9.41289L6.00039 6.52539L3.11289 9.41289Z",
    fill: "#E45050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6c39ea291430fdf0b1b4b0e4bb966f4d.svg";
export { ForwardRef as ReactComponent };